var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ModalFullScreen", {
        attrs: { size: "7xl", withBgClickEvent: true },
        on: {
          close: function ($event) {
            return _vm.$emit("close")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "flex justify-between items-center" },
                  [
                    _c(
                      "h2",
                      {
                        staticClass:
                          "text-xl font-semibold text-gray-800 divide-x divide-gray-200",
                      },
                      [
                        _c("span", { staticClass: "pr-3 capitalize" }, [
                          _vm._v(
                            _vm._s(_vm.timesheet?.user?.given_name || "") +
                              " " +
                              _vm._s(_vm.timesheet?.user?.family_name || "")
                          ),
                        ]),
                        _c("span", { staticClass: "pl-3" }, [
                          _vm._v(
                            "Timesheet period: " +
                              _vm._s(
                                _vm.gettimeRangeFormat(
                                  _vm.timesheet?.start_date,
                                  _vm.timesheet?.end_date
                                )
                              )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass:
                          "ml-2 text-gray-400 hover:text-gray-500 focus:text-gray-500 focus:outline-none",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("close")
                          },
                        },
                      },
                      [_c("CrossIconNew", { staticClass: "h-5 w-5" })],
                      1
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "wrapper" },
                  [
                    _c(
                      "div",
                      { staticClass: "buttons" },
                      [
                        _c("UiButton", {
                          attrs: {
                            buttonText: "Reject",
                            buttonClasses: "px-2 pr-3.5 pl-3.5 customHeight",
                            variant: "white",
                          },
                          on: { click: _vm.handleOpenRejectModal },
                        }),
                        _c("UiButton", {
                          attrs: {
                            buttonText: "Approve",
                            buttonClasses: "px-2 pr-3.5 pl-3.5 customHeight",
                            variant: "black",
                          },
                          on: { click: _vm.handleApproved },
                        }),
                      ],
                      1
                    ),
                    _c("TableView", {
                      attrs: {
                        columns: _vm.columns,
                        data: _vm.timesheet?.project_activity_times,
                        hasActions: true,
                        loading: _vm.loading,
                        showSelect: false,
                      },
                      on: { projectClick: _vm.handleProjectRoute },
                      scopedSlots: _vm._u([
                        {
                          key: "created_at",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatDate(row.tracked_date)) +
                                  " "
                              ),
                            ]
                          },
                        },
                        {
                          key: "note",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleShowNote(row.notes)
                                    },
                                  },
                                },
                                [_c("FileFilled")],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "rate",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatCurrency(
                                      _vm.timesheet?.contractor?.rate
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "hours",
                          fn: function ({ row }) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.convertSecondsToHoursMinutesSeconds(
                                      row.time
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "status",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "status",
                                  class: _vm.statusClasses(row?.status),
                                },
                                [_vm._v(_vm._s(_vm.status(row?.status)))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center justify-end total-hours p-2 font-semibold",
                      },
                      [
                        _vm._v(" Total hours tracked "),
                        _c("span", { staticClass: "ml-1 inline-block" }, [
                          _vm._v(
                            _vm._s(
                              _vm.totalTimeTrack(_vm.timesheet.tracked_time)
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.showRejectModal
        ? _c("RejectionModal", {
            attrs: { name: _vm.timesheet?.user?.given_name },
            on: { submit: _vm.handleRejct, close: _vm.handleCloseRejectModal },
          })
        : _vm._e(),
      _vm.showNoteModal
        ? _c("NoteModal", {
            attrs: { message: _vm.note },
            on: {
              close: function ($event) {
                _vm.showNoteModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }